import React from 'react';
import { FileText, CheckCircle, Clock, ThumbsUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const HowItWorks = () => {
  const steps = [
    {
      icon: FileText,
      number: '1',
      title: 'Kontakt aufnehmen',
      description: 'Rufen Sie uns an, schreiben Sie per WhatsApp oder nutzen Sie unser Kontaktformular.'
    },
    {
      icon: CheckCircle,
      number: '2',
      title: 'Unterlagen bereitstellen',
      description: 'Wir prüfen Ihre Dokumente kostenlos und teilen Ihnen mit, was benötigt wird.'
    },
    {
      icon: Clock,
      number: '3',
      title: 'Zulassung durchführen',
      description: 'Wir erledigen alle Behördengänge für Sie. Bei Schnellzulassung: fertig in 20 Minuten.'
    },
    {
      icon: ThumbsUp,
      number: '4',
      title: 'Fahrzeug abholbereit',
      description: 'Sie erhalten Ihre Papiere und können sofort losfahren. Einfach und stressfrei.'
    }
  ];

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            So funktioniert's
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            In vier einfachen Schritten zu Ihrer Fahrzeugzulassung
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-8 h-full border border-gray-200">
                  {/* Number Badge */}
                  <div className="absolute -top-4 -left-4 w-12 h-12 bg-blue-900 text-white rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 mt-4">
                    <IconComponent className="w-6 h-6 text-blue-900" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Connector Line (desktop only) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gray-300" />
                )}
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            size="lg"
            onClick={scrollToContact}
            className="bg-blue-900 hover:bg-blue-800 text-white px-8 py-6 text-lg rounded-lg shadow-lg"
          >
            Jetzt Anfrage stellen
          </Button>
        </div>
      </div>
    </section>
  );
};